"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationStepRoot = exports.PaginationRoot = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../constants");
var _utils = require("../utils");
const loading = (0, _mui.keyframes)`
  100% {
    background-position: left;
  }
`;
const PaginationRoot = exports.PaginationRoot = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  position = 'inside',
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  textAlign: 'center',
  width: '100%',
  zIndex: 3,
  ...(position === 'inside' && {
    bottom: '15px',
    left: '0',
    position: 'absolute'
  }),
  ...(position === 'outside' && {
    marginTop: theme.spacing(_constants.PAGINATION_MOBILE_MARGIN),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(_constants.PAGINATION_DESKTOP_MARGIN)
    }
  })
}));
const PaginationStepRoot = exports.PaginationStepRoot = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  autoplay,
  hidden,
  isActive,
  isNext,
  isPrevious,
  pagination,
  theme
}) => {
  const style = {
    background: isActive ? theme.palette.default.dark : theme.palette.grey[400],
    borderRadius: '50%',
    cursor: isActive ? 'default' : 'pointer',
    display: hidden ? 'none' : 'inline-block',
    height: (0, _utils.getDotSize)({
      isActive,
      isNext,
      isPrevious
    }),
    margin: theme.spacing((0, _utils.getDotMargin)({
      isActive,
      isNext,
      isPrevious
    }), 1),
    opacity: '1',
    transition: 'margin 300ms, background 300ms, width 300ms, height 300ms',
    verticalAlign: 'middle',
    width: (0, _utils.getDotSize)({
      isActive,
      isNext,
      isPrevious
    }),
    '&:hover': {
      animation: 'none'
    }
  };
  if (pagination?.style === 'rectangles') {
    style.background = isActive ? theme.palette.text.primary : (0, _mui.alpha)(theme.palette.common.black, 0.3);
    style.backdropFilter = 'blur(15px) brightness(106%)';
    style.borderRadius = '900px';
    style.height = '6px';
    style.width = (0, _utils.getRectangleWidth)({
      isNext,
      isPrevious
    });
  }
  if (autoplay?.enabled && isActive) {
    style.animation = `${loading} ${autoplay.interval ?? 0}ms 0s forwards linear`;
    style.backgroundSize = '200% 100%';
    style.backgroundPosition = 'right';
    style.transition = 'width 300ms, height 300ms';
    if (pagination?.style === 'dots') {
      style.background = `linear-gradient(to right, ${theme.palette.blueGrey['300']} 50%, ${theme.palette.grey.A200} 0)`;
      style.borderRadius = '5px';
      style.height = (0, _utils.getDotSize)();
      style.width = '20px';
    }
    if (pagination?.style === 'rectangles') {
      style.background = `linear-gradient(to right, ${theme.palette.text.primary} 50%, ${(0, _mui.alpha)(theme.palette.common.black, 0.3)} 0)`;
    }
  }
  return style;
});
//# sourceMappingURL=pagination.js.map